
import React from 'react';
import styles from './Loader.module.css';
import styled, { css } from 'styled-components';

const Wrapper = styled.div`
  width: ${props => props.width ? props.width : 'auto'};
  margin: ${props => props.margin ? props.margin : 'auto'};
  flex-direction: column;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  ${props => props.overlay &&
    css`
      position: fixed;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 50;
      top: 0;
      left: 0;
      overflow: auto;
      width: 100%;
      height: 100%;
    `}
`;

export const Loader = ({ overlay }) => {
    return (
        <Wrapper overlay={overlay}>
            <div className={styles.spinner}>
                <div className={styles.bounce1}></div>
                <div className={styles.bounce2}></div>
                <div className={styles.bounce3}></div>
            </div>
        </Wrapper>
    );
};